import type { Operator } from 'react-querybuilder';
import { DataConditionOperator } from 'src/graphql/entities/behavior/behavior-config/behavior-config.types';

/** The operators a support-policy condition supports; the shared evaluator maps them to set membership. */
export const SUPPORT_POLICY_CONDITION_OPERATORS: Operator[] = [
  { name: DataConditionOperator.In, label: 'In' },
  { name: DataConditionOperator.NotIn, label: 'Not in' },
];

/**
 * Date and date-time properties compare against a single date instead of a set. `Equals` reads as
 * "On" because the shared evaluator compares calendar days in the partner timezone for it — an
 * exact-timestamp equality would never match a date the user picked. Is empty / Is not empty take
 * no date, so they are unary and the query builder hides the value editor for them.
 */
export const SUPPORT_POLICY_DATE_CONDITION_OPERATORS: Operator[] = [
  { name: DataConditionOperator.Equals, label: 'On' },
  { name: DataConditionOperator.Before, label: 'Before' },
  { name: DataConditionOperator.After, label: 'After' },
  { name: DataConditionOperator.Empty, label: 'Is empty', arity: 'unary' },
  { name: DataConditionOperator.NotEmpty, label: 'Is not empty', arity: 'unary' },
];

const VALUELESS_OPERATORS: ReadonlySet<string> = new Set(
  SUPPORT_POLICY_DATE_CONDITION_OPERATORS.filter(({ arity }) => arity === 'unary').map(
    ({ name }) => name,
  ),
);

/** Whether a condition with this operator is complete without a value. */
export const isValuelessConditionOperator = (operator: unknown): boolean =>
  typeof operator === 'string' && VALUELESS_OPERATORS.has(operator);
